<template>
  <v-link
    class="card"
    :class="{ '-banner': page.card.banner_layout }"
    :to="{ name: page.slug }"
  >
    <div class="image-container" v-if="page.card.image">
      <div
        class="image"
        :style="{ backgroundImage: `url(${page.card.image.url})` }"
      />
    </div>
    <div
      class="content"
      :style="{
        backgroundColor: page.banner ? page.banner.colour : page.card.colour,
      }"
    >
      <div class="content-text">
        <p class="title -regular -t3 -white">
          {{ page.card.title ? page.card.title : page.title }}
        </p>
        <p class="text" v-html="page.card.text" />
      </div>
      <v-button class="button" :narrow="true">See More</v-button>
    </div>
  </v-link>
</template>

<script>
import VButton from "@/components/Button";
import VLink from "@/components/Link";
export default {
  props: {
    page: Object,
  },
  components: {
    VButton,
    VLink,
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.card {
  padding: vw-relative(0 13 26, 320);
  height: 100%;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  @include breakpoint(medium) {
    padding: vw-relative(0 13 26);
  }
  &.-banner {
    @include breakpoint(medium) {
      flex-direction: row;
    }
  }
}
.image-container {
  width: 100%;
  .-banner & {
    @include breakpoint(medium) {
      width: calc(100% / 3 - #{vw-relative(13)});
    }
  }
}
.image {
  padding-top: 56%;
  background-size: cover;
  background-position: center;
  .-banner & {
    @include breakpoint(medium) {
      // padding: 0;
      min-height: 100%;
    }
  }
}
.content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: vw-relative(20 20, 320);
  @include breakpoint(medium) {
    padding: vw-relative(22 25);
  }
}
.content-text {
}
.title {
  margin-bottom: 0.4em;
}
.text {
  margin-bottom: 0.8em;
}
.button {
  font-weight: 400;
  width: 70%;
}
</style>
